
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M20 .5v39M26.37 3.89l-6.12 6.21M13.63 3.99l6.21 6.12M13.63 36.11l6.12-6.21M26.37 36.01l-6.21-6.12M39.5 20H.5M26.25 13.75l-12.5 12.5M26.25 26.25l-12.5-12.5M36.11 26.37l-6.21-6.12M36.01 13.63l-6.12 6.21M3.89 13.63l6.21 6.12M3.99 26.37l6.12-6.21"}})])
          )
        }
      }
    